import { render } from "./SkeletonCourseCard.vue?vue&type=template&id=52b657ee"
import script from "./SkeletonCourseCard.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__